// src/services/university/universityConstants.js
// Constantes compartidas del marketplace de cursos AVlink University.
// Si cambia algo en la BD (course_settings) hay que reflejarlo aca y viceversa.

export const COURSE_TYPES = [
  {
    value: 'on_demand',
    label: 'On demand',
    description: 'Videos pregrabados divididos en lecciones. El alumno aprende a su ritmo.'
  },
  {
    value: 'live_webinar',
    label: 'En vivo (webinar)',
    description: 'Sesion unica en vivo por Zoom, Meet o Teams. El instructor debe subir la grabacion hasta 48 hs despues.'
  },
  {
    value: 'document',
    label: 'Libro o documento',
    description: 'Material descargable (PDF) de autoria propia del instructor. No se aceptan materiales de terceros.'
  }
];

export const COURSE_LEVELS = [
  { value: 'beginner', label: 'Principiante' },
  { value: 'intermediate', label: 'Intermedio' },
  { value: 'advanced', label: 'Avanzado' },
  { value: 'all_levels', label: 'Todos los niveles' }
];

export const COURSE_CATEGORIES = [
  { value: 'audio', label: 'Audio profesional' },
  { value: 'video', label: 'Video y broadcast' },
  { value: 'lighting', label: 'Iluminacion' },
  { value: 'staging', label: 'Escenario y rigging' },
  { value: 'live_events', label: 'Eventos en vivo' },
  { value: 'streaming', label: 'Streaming y produccion remota' },
  { value: 'integration', label: 'Integracion AV' },
  { value: 'business', label: 'Gestion y negocios AV' },
  { value: 'software', label: 'Software y consolas' },
  { value: 'other', label: 'Otro' }
];

export const COURSE_STATUSES = {
  draft: { label: 'Borrador', color: 'gray' },
  pending_review: { label: 'En revision', color: 'amber' },
  approved: { label: 'Aprobado', color: 'emerald' },
  rejected: { label: 'Rechazado', color: 'red' },
  published: { label: 'Publicado', color: 'emerald' },
  archived: { label: 'Archivado', color: 'gray' }
};

export const LIVE_PLATFORMS = [
  { value: 'zoom', label: 'Zoom' },
  { value: 'meet', label: 'Google Meet' },
  { value: 'teams', label: 'Microsoft Teams' },
  { value: 'other', label: 'Otra plataforma' }
];

export const INSTRUCTOR_TERMS_VERSION = '2026-05-19';
export const REVIEW_WINDOW_DAYS = 14;
export const WEBINAR_RECORDING_DEADLINE_HOURS = 48;

export const STORAGE_BUCKETS = {
  videos: 'course-videos',
  documents: 'course-documents',
  thumbnails: 'course-thumbnails',
  instructorAssets: 'instructor-assets'
};

export const MIN_PRICE_USD = 5;
export const MAX_PRICE_USD = 500;

// Util para formatear precios en USD desde centavos.
export function formatPriceCents(cents, currency = 'USD') {
  if (cents === null || cents === undefined) return '-';
  const amount = Number(cents) / 100;
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      maximumFractionDigits: 2
    }).format(amount);
  } catch {
    return `$${amount.toFixed(2)} ${currency}`;
  }
}

export function slugifyTitle(title) {
  if (!title) return '';
  return String(title)
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .slice(0, 80);
}
